
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60808_5491)","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 7.5A3.744 3.744 0 0115 9M1 9a3.744 3.744 0 013-1.5M8 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM4.5 13.5a4.062 4.062 0 017 0M10.063 5A2 2 0 1112 7.5M4 7.5A2 2 0 115.938 5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60808_5491"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    